var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.temVozes
    ? _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            top: "",
            "content-class": "voz-select__menu"
          },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _c(
                      "button",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass:
                              "voz-select__gatilho ia-texto-auxiliar",
                            class: {
                              "voz-select__gatilho--so-icone": _vm.soIcone
                            },
                            attrs: {
                              type: "button",
                              disabled: _vm.disabled,
                              "aria-label": _vm.soIcone
                                ? _vm.tooltipDoChip
                                : null,
                              title: _vm.soIcone ? _vm.tooltipDoChip : null
                            }
                          },
                          "button",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c("icon-svg", {
                          attrs: {
                            name: "mdi-volume-high",
                            size: _vm.TAMANHO_ICONE,
                            color: "var(--primary)"
                          }
                        }),
                        !_vm.soIcone
                          ? _c("span", { staticClass: "text-truncate" }, [
                              _vm._v(_vm._s(_vm.rotuloChip))
                            ])
                          : _vm._e(),
                        !_vm.soIcone
                          ? _c("icon-svg", {
                              attrs: {
                                name: "mdi-chevron-down",
                                size: 10,
                                color: "var(--neutral-400)"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                }
              }
            ],
            null,
            false,
            1460922064
          ),
          model: {
            value: _vm.aberto,
            callback: function($$v) {
              _vm.aberto = $$v
            },
            expression: "aberto"
          }
        },
        [
          _c(
            "div",
            { staticClass: "voz-select__painel" },
            _vm._l(_vm.linhas, function(voz) {
              return _c(
                "div",
                { key: voz.id, staticClass: "voz-select__linha" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "voz-select__opcao ia-texto-corpo",
                      class: {
                        "voz-select__opcao--ativa": voz.id === _vm.vozAtivaId
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.escolher(voz)
                        }
                      }
                    },
                    [
                      voz.id === _vm.vozAtivaId
                        ? _c("icon-svg", {
                            attrs: {
                              name: "mdi-check",
                              size: _vm.TAMANHO_ICONE,
                              color: "var(--primary)"
                            }
                          })
                        : _vm._e(),
                      _c("span", { staticClass: "text-truncate" }, [
                        _vm._v(_vm._s(voz.rotulo))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "voz-select__ouvir",
                      attrs: {
                        type: "button",
                        disabled: _vm.amostraTocandoId === voz.id,
                        "aria-label": voz.rotuloOuvir,
                        title: voz.rotuloOuvir
                      },
                      on: {
                        click: function($event) {
                          return _vm.ouvir(voz, $event)
                        }
                      }
                    },
                    [
                      _vm.amostraTocandoId === voz.id
                        ? _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              size: "12",
                              width: "2",
                              color: "var(--primary)"
                            }
                          })
                        : _c("icon-svg", {
                            attrs: {
                              name: "mdi-play",
                              size: 12,
                              color: "var(--neutral-600)"
                            }
                          })
                    ],
                    1
                  ),
                  voz.erro
                    ? _c(
                        "p",
                        {
                          staticClass: "voz-select__erro ia-texto-auxiliar",
                          attrs: { role: "alert" }
                        },
                        [_vm._v(" " + _vm._s(voz.erro) + " ")]
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }